import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { UserService } from "../../../Shared/Services/user.service";
import{default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/Trades-Columns.json';
import { APIURL } from "../../../Shared/Constant/API_Urls";
import { GridService } from "../../../Shared/Services/grid.service";
import { HttpErrorResponse } from "@angular/common/http";
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { Subscription } from 'rxjs';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { generateCsv, asBlob } from "export-to-csv";
import { MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
import { SymbolPanelComponent } from 'app/Shared/Component/symbol-panel/symbol-panel.component';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { GridComponent } from 'app/Shared/Modules/non-transactional-grid/grid/grid.component';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-trades',
    imports: [SymbolPanelComponent, FilterPanelComponent, GridComponent, QuickSearchComponent, CommonModule, MatProgressSpinner,
        ToastModule, FormsModule, MatTooltipModule],
    templateUrl: './trades.component.html',
    styleUrls: ['./trades.component.scss']
})
export class TradesComponent implements OnInit,OnChanges, OnDestroy{
  quickFilterArray: any = GridColumnsJSON["Trades-Quick-Search-Fields"];
  GridColumns = GridColumnsJSON["Trades-Grid-Columns"];
  TradesOptedExportCSVGridColumns = GridColumnsJSON["Trades-Opted-Export-CSV-Grid-Columns"];
  dataset1: any[] = [];
  LastClientExecutionDate!: any[];
  ActiveSymbol: any;
  SymbolsArray: any = [];
  DefaultFilterArray: any = [];
  isLoadingResults = true;

  Limit: any = { 'Start': '', 'End': '' };
  totalRecords: any;
  rowcount!: number;
  startLimit: any = 0;
  endLimit!: number;
  subscription!: Subscription;
  public displayTildCount:boolean = false;

  constructor(
    private userService: UserService,
    private gridService: GridService,
    private emitterService: EmitterService,
    private messageService: MessageService,
    private constantService: ConstantService) {
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
    this.rowcount=this.gridService.getGridRowsCount();
    this.Limit = { 'Start': '0', 'End': this.rowcount };
    this.totalRecords = this.rowcount;
    this.dataset1 = [];
    this.defaultFilter();
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
  }

  updateDefaultArray($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.getSymbols();
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.getSymbols();
    this.getData();
  }

  FilterEventClearSymbol(event: any) {
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.emitterService.ResetQuickFilterPanelEvent.emit("Symbol");
  }


  FilterApplyFilterEvent(event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.startLimit = 0;
    this.Limit.Start = 0;

    this.getSymbols();
    this.getData();
  }

  setActiveSymbolEvent(event: any) {
    this.ActiveSymbol = event;
    for (let i = 0; i < this.DefaultFilterArray.length; i++) {
      if (this.DefaultFilterArray[i].label.toLocaleLowerCase() == 'symbol') {
        this.DefaultFilterArray[i].values = this.ActiveSymbol;
        this.startLimit = 0;
        this.Limit.Start = 0;
        this.totalRecords = 0;
        this.emitterService.ReloadQuickFilterPanelEvent.emit("true");
        this.getData();
        break;
      }
    }
  }

  GridResetSymbolEvent(event: any) {
    this.startLimit = 0;
;
    this.Limit.Start = 0;
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.emitterService.ResetQuickFilterPanelEvent.emit('All');
  }

  GridChangeLimitEvent(event: any) {
    this.Limit = event;
    this.getData();
  }

  defaultFilter() {
    /*** Get Last CAT Execution date*/
    let date:any;
    date=this.userService.getDatesForClientData();
      this.LastClientExecutionDate = [];
      this.LastClientExecutionDate.push(date[0]);//Fromdate
      this.LastClientExecutionDate.push(date[0]);//Todate
    
    if (date != "" && date != null) {
      //Todate
      this.DefaultFilterArray = [
        { "isdefault":  "true", "label": "clientDataDate", 'dateDropDown':[
          { label: 'Trade Date', value: 'Order Date'},
          { label: 'Report Date', value: 'Report Date'},
        ], "dateFilterBy": "Trade Date", "dateFilterValue": "", "columnname": "TradeDate", "filterby": "", "values": this.LastClientExecutionDate, "time": "", "datatype": "DateRange","disabled": true },
        { "isdefault":  "true","label": "Symbol", "columnname": "Symbol", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true },
        { "isdefault":  "true","label": "Trade ID", "columnname": "TradeID", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true },
        { "isdefault":  "true", "label": "Event Type", "columnname": "EventType", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
        {
          "isdefault":"true",
          "label":"Order ID",
          "columnname":"OrderID",
          "filterby":"IS",
          "values":"",
          "time":"",
          "datatype":"String",
          "disabled":"false"
       },
       {
          "isdefault":"true",
          "label":"OMS Order ID",
          "columnname":"OMSOrderID",
          "filterby":"IS",
          "values":"",
          "time":"",
          "datatype":"String",
          "disabled":"false"
       },
       {
          "isdefault":"true",
          "label":"Side",
          "columnname":"BuySellCode",
          "filterby":"IS",
          "values":"",
          "time":"",
          "datatype":"String",
          "disabled":"false"
       },
       {
          "isdefault":"true",
          "label":"Trd Qty",
          "columnname":"Quantity",
          "filterby":"=",
          "values":"",
          "time":"",
          "datatype":"float",
          "disabled":"false"
       },
       {
          "isdefault":"true",
          "label":"Trd Price",
          "columnname":"Price",
          "filterby":"=",
          "values":"",
          "time":"",
          "datatype":"Float",
          "disabled":"false"
       },
       {
          "isdefault":"true",
          "label":"Act Ref Num",
          "columnname":"ActRefNum",
          "filterby":"IS",
          "values":"",
          "time":"",
          "datatype":"String",
          "disabled":"false"
       },
       {
          "isdefault":"true",
          "label":"Contra Broker MPID",
          "columnname":"ContraBrokerMPID",
          "filterby":"IS",
          "values":"",
          "time":"",
          "datatype":"String",
          "disabled":"false"
       },
       {
          "isdefault":"true",
          "label":"Execution Venue",
          "columnname":"ExecutionVenue",
          "filterby":"IS",
          "values":"",
          "time":"",
          "datatype":"String",
          "disabled":"false"
       },
       {
          "isdefault":"true",
          "label":"RootOrderID",
          "columnname":"rootOrderID",
          "filterby":"IS",
          "values":"",
          "time":"",
          "datatype":"String",
          "disabled":"false"
       },
       {
        "isdefault": "true",
        "label": "OMSSystem",
        "columnname": "OMSSystem",
        "filterby": "IS",
        "values": "",
        "time": "",
        "datatype": "String",
        "disabled": "false"
      }
      ];

    }
    this.Limit.Start=0;
    this.getSymbols();
    this.getData();
  }

  getSymbols() {
    this.SymbolsArray = [];/***RESET ARRAY*/
    this.gridService.getSymbol(APIURL.QuickFilterFields, this.DefaultFilterArray, this.Limit,"Trades")
      .subscribe({
        next: (Element:any) => {
        let Symbol: any = Element;
          this.SymbolsArray = Symbol.SymbolList;},  error: (err: HttpErrorResponse) => {
        //alert(err);
      }});
  }
  getData() {
    this.isLoadingResults = true;
    this.gridService.prepareData(APIURL.Trades, this.DefaultFilterArray,this.Limit,"Trades")
      .subscribe({
        next: (Element:any) => {
        this.isLoadingResults = false;
        let dataset: any = Element;
        this.dataset1 = dataset.Data;
        this.totalRecords= dataset.totalCount;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        this.totalRecords = this.totalRecords;
        this.displayTildCount = true;
        this.gridService.prepareData(APIURL.TradesCount, this.DefaultFilterArray,this.Limit,"Trades")
          .subscribe({
            next: (Element:any) => {
            let dataset: any = Element;
            this.displayTildCount = false;
            this.totalRecords= dataset.totalCount;
            this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
            // if(this.dataset1 !=null && this.dataset1.length != 0)
            // this.SymbolsArray=this.gridService.prepareSymbols(this.dataset1);
          }, error: (err: HttpErrorResponse) => {
            //alert(err);
            this.totalRecords= 0;
            this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          }});
      }, error: (err: HttpErrorResponse) => {
        //alert(err);
        this.dataset1 = [];
        this.isLoadingResults = false;
      }});

     
  }
  exportToCSV(response : any) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    if (response.event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      this.Limit = { 'Start': response.Start.toString(), 'End': response.End.toString()};;
    }
    this.gridService.prepareData(APIURL.Trades, this.DefaultFilterArray, this.Limit,"Trades")
      .subscribe({
        next: (Element:any) => {

      let dataset: any = Element;
      let data = dataset.Data;

      if (data.length > 0) {
        data.forEach((col: { originalJSON: any; }) => {
          delete col.originalJSON;
        });
        const options : any = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: 'RSMS_Trades_' + this.userService.getyyyyMMddDateFormate(new Date()),
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
          filename: this.userService.getActiveMPID() +'_RSMS_Trades_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
        };
        const csvData = this.constantService.getExportData(data, response.event.gridColumn);
        const csv = generateCsv(options)(csvData);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);
        this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam : any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'No data found',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam : any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
      this.emitterService.exportToCSVData.emit(true);

    }, error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.userService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam : any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }});
  }

  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }

}